module.exports = __webpack_public_path__ + "static/media/AarjavJain_Resume.34ec599e.pdf";